import { apiService } from './api';

export interface CreateWarehouseDTO {
  code: string;
  name: string;
  location: string;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
}

export interface UpdateWarehouseDTO extends CreateWarehouseDTO {
  isActive: boolean;
}

const WAREHOUSES_API = '/organization/warehouses';

const warehouseService = {
  getWarehouses: (pageNumber: number = 1, pageSize: number = 100) =>
    apiService.get<any[]>(WAREHOUSES_API, {
      pageNumber,
      pageSize,
    }),

  getWarehouseById: (id: number) =>
    apiService.get<any>(`${WAREHOUSES_API}/${id}`),

  createWarehouse: (data: CreateWarehouseDTO) =>
    apiService.post<any>(WAREHOUSES_API, data),

  updateWarehouse: (id: number, data: UpdateWarehouseDTO) =>
    apiService.put<any>(`${WAREHOUSES_API}/${id}`, data),

  deleteWarehouse: (id: number) =>
    apiService.delete<void>(`${WAREHOUSES_API}/${id}`),
};

export default warehouseService;
